import {
  TopicSet,
  clientId,
  QType,
  RULE,
  Utype,
  Vtype,
  Rtype,
  QDefSets,
  QDefValue,
  TimeScale,
  Link,
  tou, Extreme
} from "./global"
import {WebSocketAPI,MqttAPI} from '../netapi/DataBus'
import {instance,dataSets} from "../../MobxStore";
import ambientList from './../../data/ambientList.json'
import ambientJson from './../../data/ambientJson.json'
import roomList from './../../data/roomList.json'
import roomJson from './../../data/roomJson.json'
import deviceList from './../../data/deviceList.json'
import deviceJson from './../../data/deviceJson.json'
import roomDevice from './../../data/roomDevice.json'
import ambientDevice from './../../data/ambientDevice.json'
import React from "react";
import DF from "./DateFormat";
import cron from 'cron'
import FileSaver from 'file-saver'

let Qkey = "";
export const Grammar = {
  init : (cb,props,link) => {
    switch (link){
      case Link.MQTT:MqttAPI.createConnection((isConnect,e) => cb(isConnect,e) ,props);break;
      case Link.HTTP:break;
      default : WebSocketAPI.createConnection((isConnect,e) => cb(isConnect,e) ,props)
    }
  },
  getRamNumber:(bits)=>{
    let result='';
    for(let i=0;i<bits;i++)result+=Math.floor(Math.random()*16).toString(16)
    return result.toUpperCase();//另toLowerCase()转小写
  },
  webGet : (cb,options) => {
    let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
    let subTopic = TopicSet.QUERY_SUB.replace("clientId",clientId).replace("messageId",msg+'');
    let pubTopic = TopicSet.QUERY_PUB.replace("beeId",options.beeId);
    WebSocketAPI.SUB(subTopic,(ret)=> {
      // console.log(ret);
      let rJson = JSON.parse(ret);
      if(rJson.friends) cb(rJson)
      else{
        let r = Object.values(rJson)?.[0]
        if(r){
          switch (options.Rtype){
            case Rtype.ToValue : cb(toValue(r,options.fixed));break;
            case Rtype.ToAxis : cb(toAxis(r));break;
            case Rtype.ToList : cb(toList(r));break;
            case Rtype.ToVArray : cb(toVArray(r));break;
            case Rtype.ToJsonArray : cb(toJsonArray(r));break;
            default : cb(toJson(r))
          }
        }
      }
    });
    // console.log(subTopic);
    // console.log(pubTopic);
    // console.log(toQuery(options));
    WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:toQuery(options)});
  },
  batchGet3 : (cb, opts) => {
    let classifyArray = {}
    if(opts && opts.length > 0){
      opts.map(o=>{
        if(o.beeId && !classifyArray[o.beeId]) classifyArray[o.beeId] = []
        classifyArray[o.beeId].push(o)
      })
    }
    Object.keys(classifyArray).map(beeId=>{
      let qProp = [],result = {}
      classifyArray[beeId].map(it=>{
        it["query"] = toQuery(it);
        result[it["id"]] = []
        qProp.push(it["query"])
      })
      let query = qProp.join(";")
      let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
      let subTopic = TopicSet.QUERY_SUB.replace("clientId",clientId).replace("messageId",msg+'');
      let pubTopic = TopicSet.QUERY_PUB.replace("beeId",beeId);
      WebSocketAPI.SUB(subTopic,(ret)=> {
        let r = JSON.parse(ret)
        console.log(r);
        opts.map((item,index)=>{
          console.log(item);
          item["query"].split(";").map(q=>{
            console.log(r[q]);
          })

          if(r[item["query"]]){
            switch (item.Rtype){
              case Rtype.ToValue : item["result"] = toValue(r[item["query"]]);break;
              case Rtype.ToAxis : item["result"] = toAxis(r[item["query"]]);break;
              case Rtype.ToVArray : item["result"] = toVArray(r[item["query"]]);break;
              case Rtype.ToList : item["result"] = toList(r[item["query"]]);break;
              case Rtype.ToJson : item["result"] = toJson(r[item["query"]]);break;
              case Rtype.ToAssignList: item["result"] = toAssignList(r[item["query"]]);break;
              default : item["result"] = toJson(r[item["query"]])
            }
            result[item["id"]].push(item["result"])
          }
        })
        cb(result)
      });
      WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:query});
    })
  },
  batchGet : (cb,opts) =>{
    // console.log(opts);
    //把 {查询条件} 和 {查询结果} 都在json中对号入座
    let query = "",qProp = []
    if(opts && opts.length > 0){
      // eslint-disable-next-line no-unused-expressions
      opts?.map(it =>{
        it["query"] = toQuery(it);
        qProp.push(it["query"])
      })
      query = qProp.join(";")
      // console.log(query);
      let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
      let subTopic = TopicSet.QUERY_SUB.replace("clientId",clientId).replace("messageId",msg+'');
      let pubTopic = TopicSet.QUERY_PUB.replace("beeId",opts[0]["beeId"]);
      WebSocketAPI.SUB(subTopic,(ret)=> {
        // console.log(ret);
        if(ret !== "{}"){
          let r = JSON.parse(ret)
          // console.log(r);
          let result = {} //结果类型为{{"id","result"}}
            opts.map((item,index)=>{
              if(!result[item["id"]]) result[item["id"]] = []
              if(item.Rtype === Rtype.ToList){
                // console.log(r,item["query"].split(";"));
              }
              if(item.Utype === Utype.TriUnit){
                let querys = item["query"].split(";")
                // console.log(querys);
                switch (item.Rtype){
                  case Rtype.ToValue :
                    item["resultA"] = toValue(r[querys[0]]);
                    item["resultB"] = toValue(r[querys[1]]);
                    item["resultC"] = toValue(r[querys[2]]);
                    item["resultAll"] = toValue(r[querys[3]]);
                    break;
                  case Rtype.ToAxis:
                    item["resultA"] = toAxis(r[querys[0]]);
                    item["resultB"] = toAxis(r[querys[1]]);
                    item["resultC"] = toAxis(r[querys[2]]);
                    break;
                  case Rtype.ToVArray:
                    item["resultA"] = toVArray(r[querys[0]]);
                    item["resultB"] = toVArray(r[querys[1]]);
                    item["resultC"] = toVArray(r[querys[2]]);
                    break;
                  case Rtype.ToList:
                    item["resultA"] = toList(r[querys[0]]);
                    item["resultB"] = toList(r[querys[1]]);
                    item["resultC"] = toList(r[querys[2]]);
                    item["resultAll"] = toList(r[querys[3]]);
                    break;
                  default :
                    item["resultA"] = toJson(r[querys[0]]);
                    item["resultB"] = toJson(r[querys[1]]);
                    item["resultC"] = toJson(r[querys[2]]);
                }
                if(item.id.indexOf("Sgl_") > -1)item["result"] = item["resultAll"]
                else item["result"] = {A:item["resultA"],B:item["resultB"],C:item["resultC"],All:item["resultAll"]};
                // console.log(item["result"]);
              }else {
                switch (item.Rtype){
                  case Rtype.ToValue : item["result"] = toValue(r[item["query"]]);break;
                  case Rtype.ToAxis : item["result"] = toAxis(r[item["query"]]);break;
                  case Rtype.ToVArray : item["result"] = toVArray(r[item["query"]]);break;
                  case Rtype.ToList : item["result"] = toList(r[item["query"]]);break;
                  case Rtype.ToJson : item["result"] = toJson(r[item["query"]]);break;
                  case Rtype.ToAssignList: item["result"] = toAssignList(r[item["query"]]);break;
                  default : item["result"] = toJson(r[item["query"]])
                }
              }
              result[item["id"]].push(item["result"])
            })
            // console.log(result);
            cb(result);
          }
      });
      WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:query});
    }
  },
  webControl : (cb, options) => {
    let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
    let subTopic = TopicSet.CONTROL_SUB.replace("clientId",clientId).replace("messageId",msg);
    let pubTopic = TopicSet.CONTROL_PUB.replace("beeId",options.beeId).replaceAll("deviceId",options.deviceId)
    console.log(subTopic);
    console.log(pubTopic);
    WebSocketAPI.SUB(subTopic, (ret)=> {
      console.log(ret);
      cb(ret)
    })
    WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:options.value})
  },
  webSub : (options) => {
    let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
    let subTopic = TopicSet.SYNC_SUB.replace("clientId",clientId).replace("beeId",options.beeId);
    let pubTopic = TopicSet.SYNC_PUB.replace("beeId",options.beeId)
    WebSocketAPI.SUB(subTopic,(ret)=> {
      // console.log(ret);
      Object.values(JSON.parse(ret)).forEach( it => {
        // console.log(it["tId"],it["v"]["f"]);
        if(!dataSets[it["tId"]])dataSets[it["tId"]] = {}
        else dataSets[it["tId"]][it["key"]] = it["v"]["f"]
      })
    });
    // console.log(subTopic);
    // console.log(pubTopic);
    // console.log(toSub(options));
    WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:toSub(options)})
  },
  webClientId : (isOffLine) => {
    if(!isOffLine){
      let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
      let subTopic = TopicSet.CLIENT_SUB.replace("clientId",clientId).replace("messageId",msg+'');
      let pubTopic = TopicSet.CLIENT_PUB;
      WebSocketAPI.SUB(subTopic,(ret)=> {
        if(ret !== undefined && ret!=="undefined" && ret.indexOf("@")>-1) {
          let BeeObj = toAmbientJson(ret)
          let beeKey = Object.keys(BeeObj)[0];
          if(beeKey !== "86528002111"){
            instance.obGateway(BeeObj)
            Grammar.webGet((ret)=>{
              let a = {}
              a[beeKey] = ret;
              instance.obIot(a)
            },{beeId:beeKey,QType:QType.AMBIENT,Utype:Utype.GATEWAY})
          }
        }
      });
      WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:'clientId='})
    }else{
      instance.obAll({
        ambientList:ambientList,
        ambientJson:ambientJson,
        roomList:roomList,
        roomJson:roomJson,
        deviceList:deviceList,
        deviceJson:deviceJson,
        roomDevice:roomDevice,
        ambientDevice:ambientDevice
      })
    }
  },
  update : (online) => {
    if(online){
      let CronJob = cron.CronJob
      const job = new CronJob("0 0 2 * * *",()=>{
        updateIot()
      },null,true)
      job.start();
    }else updateIot()
  },
  Vformat : (v,u,a) =>{
    let value = v;
    if(u?.charAt(0) === 'M')value = v/1000000;
    if(u?.charAt(0) === 'k')value = v/1000;
    if(u?.charAt(0) === 'm')value = v*1000;
    if(u?.charAt(0) === 'w')value = v/10000;
    switch(a){
      case 'I':value = parseInt(value);break;
      case "1":value = parseFloat(value).toFixed(1);break;
      case "2":value = parseFloat(value).toFixed(2);break;
      case "3":value = parseFloat(value).toFixed(3);break;
    }
    return value;
  },
  customQSet : (dataJson) =>{
    let defV = JSON.parse(JSON.stringify(QDefValue))
    Object.keys(defV).forEach(it=>{
      if(typeof (defV[it]) === "object"){
        switch (dataJson.Utype) {
          case Utype.GATEWAY:defV[it]["beeId"] = dataJson.gateway?.beeId;break;
          case Utype.ROOM:defV[it]["beeId"] = dataJson.room?.beeId;break;
          case Utype.TERMINAL:defV[it]["beeId"] = dataJson.device?.beeId;break;
        }
        defV[it]["roomId"] = dataJson.room?.roomId;
        defV[it]["deviceId"] = dataJson.device?.deviceId;
        defV[it]["Utype"] = dataJson.Utype;
      }
    })
    return Object.assign(dataJson,defV)
  },
  toDeviceJson : (ret) => {
    let toBe = ret.replaceAll("Terminal","").replaceAll("(","").replaceAll(")","").replaceAll("\"","").trim()
    let items = toBe?.split(","),value = {}
    items && items.map( it => value[it.split("=")[0].trim()] = it.split("=")[1].trim())
    return value
  },
  extremeAnnotations : (opt,series,points) => {
    points && points.map((p,i)=>{
      switch (p) {
        case Extreme.MAX:
          let maxPoint = Grammar.maxSeriesPoint(series);
          opt.annotations[0].labels[0] = {
            point: {xAxis:0, yAxis:0, x:maxPoint[0], y:maxPoint[1]},
            x: -30,
            text: DF.format("HH:mm:ss",maxPoint[0])+': 最大值 ' + maxPoint[1]
          }
          break;
        case Extreme.MIN:
          let minPoint = Grammar.minSeriesPoint(series);
          opt.annotations[0].labels[1] = {
            point: {xAxis:0, yAxis:0, x:minPoint[0], y:minPoint[1]},
            y: 30,
            text: DF.format("HH:mm:ss",minPoint[0])+ '最小值' + minPoint[1]
          }
          break;
      }
    })
    return opt;
  },
  maxSeriesPoint : (series) => {
    let newSeries = New(series)
    return newSeries?newSeries.sort((a,b)=>b[1]-a[1])[0]:[]
  },
  minSeriesPoint : (series) => {
    let newSeries = New(series)
    return newSeries?newSeries.sort((a,b)=>a[1]-b[1])[0]:[]
  },
}

export const PVETL = (series) => {
  series.map((s,i)=>{
    let h = DF.format("HH",s[0])
    if(parseInt(h) < 6 || parseInt(h) > 18)s[1] = 0
    if(parseFloat(s[1]) > 200000) s[1] = series[i-1][1]
    if(i>0 && Math.abs(parseFloat(series[i][1]) - parseFloat(series[i-1][1]) ) > 18000) s[1] = series[i-1][1]
  })
  return series
}

export const preProcess = (data,range) => {
  let newData = []
  data.map(d=>{
    if(d[1] > range[0] && d[1] < range[1]) newData.push(d)
  })
  return newData;
}

export const updateIot = () => {
  let ambientList = [],ambientJson = {}, roomList = [], roomJson = {}, deviceList = [],
    deviceJson = {},roomDevice = {},ambientDevice = {}, ambientRoom = {}
  let msg = new Date().valueOf() + parseInt(Math.random() * 123456 + '')
  let subTopic = TopicSet.CLIENT_SUB.replace("clientId",clientId).replace("messageId",msg+'');
  let pubTopic = TopicSet.CLIENT_PUB;
  WebSocketAPI.SUB(subTopic,(ret)=> {
    if(ret !== undefined && ret!=="undefined" && ret.indexOf("@")>-1) {
      let target = toAmbientJson(ret)
      ambientJson = Object.assign(ambientJson,target)
      let beeId = Object.keys(target)[0],beeObj = Object.values(target)[0]
      beeObj["beeId"] = beeId
      ambientList.push(beeObj)
      Grammar.webGet((ret)=>{
        let rooms = ret.rooms;
        rooms.map(r=>{
          let room = r.t
          roomJson[room.id] = room
          roomJson[room.id]["beeId"] = beeId
          roomList.push(room)
          if(!ambientRoom[beeId])ambientRoom[beeId] = []
          ambientRoom[beeId].push(room)
          let devices = r.terminals;
          devices && devices.map(d=>{
            if(d.id.indexOf("/") > -1)d["deviceId"] = d.id.split("/")[0]
            // d["deviceId"] = d.id;
            deviceList.push(d)
            d["roomId"] = room.id;
            d["beeId"] = beeId;
            deviceJson[d.id] = d;
            if(!roomDevice[room.id])roomDevice[room.id] = []
            roomDevice[room.id].push(d)
            if(!ambientDevice[beeId])ambientDevice[beeId] = []
            ambientDevice[beeId].push(d)
          })
        })
        // instance.obIot(a)
      },{beeId:beeId,QType:QType.AMBIENT,Utype:Utype.GATEWAY})
    }
  });
  WebSocketAPI.PUB(pubTopic,{clientId:clientId,messageId:msg,value:'clientId='})

  setTimeout(()=>{
    FileSaver.saveAs(
      new Blob([JSON.stringify(ambientList)], { type: 'text/plain;charset=utf-8' }),
      `ambientList.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(ambientJson)], { type: 'text/plain;charset=utf-8' }),
      `ambientJson.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(roomList)], { type: 'text/plain;charset=utf-8' }),
      `roomList.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(roomJson)], { type: 'text/plain;charset=utf-8' }),
      `roomJson.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(deviceList)], { type: 'text/plain;charset=utf-8' }),
      `deviceList.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(deviceJson)], { type: 'text/plain;charset=utf-8' }),
      `deviceJson.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(roomDevice)], { type: 'text/plain;charset=utf-8' }),
      `roomDevice.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(ambientDevice)], { type: 'text/plain;charset=utf-8' }),
      `ambientDevice.json`
    );
    FileSaver.saveAs(
      new Blob([JSON.stringify(ambientRoom)], { type: 'text/plain;charset=utf-8' }),
      `ambientRoom.json`
    );
  },10000)
}

export const Tofixed = (kvArray,num) => {
  console.log(kvArray);
  kvArray && kvArray.map(kv=>{
    console.log(kv)
    // [kv[0],kv[1].toFixed(num)]
  })
}

export const arraySupplement = (arr,bit) => {
    if(!arr || arr.length < bit){
    while (arr.length < bit){
      arr.push(0)
    }
  }
  return arr;
}

export const interceptSeries = (series,range) => {
  return series.filter(s=>((s[0] >= range[0]) && (s[0] <= range[1])) )
}

export const touEnergy = (eList) => {
  let peak = 0, flat = 0, valley = 0
  eList && tou && eList.map((e,i)=>{
    if(tou[i] === -1)valley += parseFloat(e);
    if(tou[i] === 0)flat += parseFloat(e);
    if(tou[i] === 1)peak += parseFloat(e);
  })
  return {peak:peak.toFixed(2),flat:flat.toFixed(2),valley:valley.toFixed(2)}
}

export const fixedFormat = (value,unit,accuracy,isAppend) => {
  let ret = value;
  if(unit){ //判断是否为千
    switch (unit) {
      case "kJ":
      case "kW":
      case "kV":
      case "kA": ret = ret/1000; break;
      case "mV":
      case "mA": ret = ret*1000; break;
      case "MJ":
      case "MW":
      case "MV":
      case "MA": ret = ret/1000000; break;
      default : break;
    }
  }
  switch (accuracy) { //判断精度
    case 'I':ret = parseInt(ret);break;
    case "1":ret = parseFloat(ret).toFixed(1);break;
    case "2":ret = parseFloat(ret).toFixed(2);break;
    case "3":ret = parseFloat(ret).toFixed(3);break;
    case "def":break;
    default : return value + "  " + (isAppend?unit:"");
  }

  //判断是否为无穷大或NaN
  if(isNaN(ret))ret = 0.0;
  if(ret === Infinity || ret === -Infinity || ret === "Infinity") ret = 1.0;

  return ret + "  " + (isAppend?unit:"")
}

export const Standard = (r) => parseFloat(parseFloat(r)?.toFixed(2))

export const Unique = (dataArray,prop) =>{ //第一个参数为待去重的对象数组，第二个参数为区分属性
  let obj = {};
  return dataArray.reduce((item, next) => {
    if(!obj[next[prop]])(obj[next[prop]] = true) &&  item.push(next)
    return item;
  }, []);
}

export const arrayAdd = (array,fixed) => {
  let myFixed = fixed || 0
  if(array.length === 1) return parseFloat(array[0]).toFixed(myFixed)
  else return array.reduce((pre,cur)=> (parseFloat(pre) + parseFloat(cur))).toFixed(myFixed)
}

export const curParamSeries = (curTs,series) => {
  let ret = []
  series && series.map((s,i)=>{
    if(series[i][0] >= curTs && series[i-1][0] <= curTs) ret = [curTs,s[1]];
  })
  return ret;
}

export const appendState = (curTs,series) => {
  let lastElement = series[series.length-1]
  if(curTs > lastElement[0])series.push([curTs,lastElement[1]])
  return series
}

export const rollSeries = (curTs,series,hours,startPoint) => {
  let start = New(curTs),end = start + hours*60*60*1000, ret = startPoint?[startPoint]:[];
  series && series.map(s=>{
    if(s[0] >= start && s[0] <= end) ret.push(s)
  })
  return ret;
}

export const iconTransfer = (Tools) =>{
  let target = {id:Tools.id,name:Tools.name,project:Tools.font_family,prefix:Tools.css_prefix_text,svgIcons:[]}
  console.log(target);
  console.log(Tools);
}

export const showReducer = (state,action) => Object.assign(New(state),JSON.parse(`{"${action.type}":${!state[action.type]}}`))
export const accordionProp = (number) => {
  let accProp = {}
  for(let i=0 ; i<number; i++)accProp[i] = true
  return accProp
}

export const AccordionInit = (list) =>{
  const initState = {}
  list.map((item,index)=>{
    initState[index] = index === 0;
  })
  return initState;
}

export const beautySub = (str, len) =>{ //超出文本长度省略号
  let reg = /[\u4e00-\u9fa5]/g,
    slice = str.substring(0, len),
    chineseCharNum = (~~(slice.match(reg) && slice.match(reg).length)),
    realen = slice.length*2 - chineseCharNum;
  return str.substr(0, realen) + (realen < str.length ? "..." : "");
}

export const convertV = (v,t) =>{ //方向 负荷准线研究，激励机制。
  switch (t){
    case 'f': return v?parseFloat(v):"";
    case 'I': return v?parseInt(v):"";
    case 'b': return Boolean(v)
    default : return v.toString();
  }
}

export const New = (ori) => {
  if(typeof ori === "object") return JSON.parse(JSON.stringify(ori))
  else return ori
}

export const DateButtonGroups = (timeScale) =>{
  let bGroup = [];
  switch (timeScale){
    case "H":
      bGroup.push({key:"prefix",CN:"前一时",EN:"lastHour",value:"前一时"},{key:"current",CN:"当前",EN:"current",value:"当前时"},{key:"next",CN:"后一时",EN:"nextHour",value:"后一时"})
      break;
    case "d":
      bGroup.push({key:"prefix",CN:"前一日",EN:"lastDay",value:"前一日"})
      bGroup.push({key:"current",CN:"当前日",EN:"current",value:"当前日"})
      bGroup.push({key:"next",CN:"后一日",EN:"nextDay",value:"后一日"})
      break;
    case "w":
      bGroup.push({key:"prefix",CN:"前一周",EN:"lastWeek",value:"前一周"})
      bGroup.push({key:"current",CN:"当前周",EN:"current",value:"当前周"})
      bGroup.push({key:"next",CN:"后一周",EN:"nextWeek",value:"后一周"})
      break;
    case "M":
      bGroup.push({key:"prefix",CN:"前一月",EN:"lastMonth",value:"前一月"})
      bGroup.push({key:"current",CN:"当前月",EN:"current",value:"当前月"})
      bGroup.push({key:"next",CN:"后一月",EN:"nextMonth",value:"后一月"})
      break;
    case "y":
      bGroup.push({key:"prefix",CN:"前一年",EN:"lastYear",value:"前一年"})
      bGroup.push({key:"current",CN:"当前年",EN:"current",value:"当前年"})
      bGroup.push({key:"next",CN:"后一年",EN:"nextYear",value:"后一年"})
      break;
  }
  return bGroup;
}

const toAmbientJson = (ret) =>{
  let props = ret.split(",");
  let ambientJson = {"channel":""},retJson = {}
  props.forEach((prop)=>{
    if(prop.includes("@")){
      let leftAt = prop.split("@")[0].replace('"','')
      let rightAt = prop.split("@")[1].replace('"','')
      ambientJson["name"] = leftAt.includes('"') ? leftAt.split('"')[leftAt.split('"').length - 1]:leftAt
      ambientJson["info"] = rightAt.includes(':') ? rightAt.split(':')[1] : rightAt
      ambientJson["beeId"] = ambientJson["info"].split("/")[1]
    }
    if(prop.includes("IP"))ambientJson["IP"] = prop.includes("=")?prop.split("=")[1]:prop.split(":")[1]
    if(prop.includes("memory"))ambientJson["memory"] = prop.includes("=")?prop.split("=")[1]:prop.split(":")[1]
    if(prop.includes("channel"))ambientJson["channel"] = prop.includes("=")?prop.split("=")[1]:prop.split(":")[1]
  })
  retJson[ambientJson["beeId"]] = ambientJson
  return retJson
}

const toSub = (options) => {
  return '['+clientId+']state.'+options.Vtype+":"+options.id;
  // switch (options.Utype){
  //   case Utype.GATEWAY: return '['+clientId+']state.'+options.Vtype+":ambient-"+options.beeId;
  //   case Utype.ROOM:return '['+clientId+']state.'+options.Vtype+":"+options.roomId;
  //   case Utype.TERMINAL:return '['+clientId+']state.'+options.Vtype+":"+options.deviceId;
  // }
}

const toValue = (ret) => { //传入默认Json 返回值 如 {a:1} => 1
  return parseFloat(Object.values(ret)[0])
}

export const toList = (ret) => { //传入Json 返回数组 如 {a:1,b:2} => [[a,1],[b,2]]
  if(ret){
    let dataList = []
    Object.keys(ret).forEach(it=>dataList.push([parseInt(it),parseFloat(ret[it])]))
    return dataList;
  }
}

const toAssignList = (ret) => {
  let retArray = []
  ret && Object.values(ret).map(item=>retArray.push(Grammar.toDeviceJson(item)))
  return retArray;
}

const toJsonArray = (ret) => { //传入Json 返回Json数组 如 {a:1,b:2} => [{a:1},{b,2}]
    let retArray = []
  Object.keys(ret).forEach(it=>{
    let a = {}
    a[it] = ret[it]
    retArray.push(a)
  })
  return retArray
}

export const optionName = (object,tag) => {
  let ret = ""
  object && object.options && object.options.map((item,index)=>{
    if(item.value === tag) ret = item.text;
  })
  return ret;
}

export const toTableList = (ret) => {
  let a = []
  Object.values(ret).forEach(it=>{
    a.push(it)
  })
  return a
}

const toJson = (ret) => { //不做修改，直接返回
  return ret
}

const toVArray = (ret) => { //传入默认Json 返回值数组 如{a:1,b:2} => [1,2]
  let dataList = []
  Object.values(ret).forEach(it=>dataList.push(it))
  return dataList;
}

const toAxis = (ret,fixed) => { //默认传入Json，返回两个数组 如{a:1,b:2} => [[a,b],[1,2]]
  let xAxis = [], yAxis = [],dataList = []
  let results = Object.values(JSON.parse(ret))[0]
  Object.keys(results).forEach( key =>{
    xAxis.push(parseInt(key))
    yAxis.push(parseFloat(results[key].toFixed(fixed===undefined?2:fixed)))
  })
  dataList.push(xAxis)
  dataList.push(yAxis)
  return dataList;
}

const toQuery = (options) => {
  switch (options.QType){
    case QType.AMBIENT : return ambientAPI(options);
    case QType.CURVE : return curveAPI(options);
    case QType.FORECAST : return forecastAPI(options);
    case QType.K : return KAPI(options);
    case QType.STATE : return stateAPI(options);
    case QType.FRIEND : return friendAPI(options);
    case QType.LOG : return logAPI(options);
    case QType.SWITCH : return switchAPI(options);
  }
}

const ambientAPI = (opts) => {
  switch (opts.Utype){
    case Utype.GATEWAY: Qkey = RULE.AMBIENT_RULE.replace(".Utype:uid","");break;
    case Utype.ROOM : Qkey = RULE.AMBIENT_RULE.replace("Utype",opts.Utype)
                                              .replace(":uid",opts.roomId===undefined?"":':'+opts.roomId);break;
    case Utype.TERMINAL : Qkey = RULE.AMBIENT_RULE.replace("Utype",opts.Utype)
                                                  .replace(":uid",opts.deviceId===undefined?"":':'+opts.deviceId);break;
  }
  return Qkey.replace("beeId",opts.beeId);
}
const curveAPI = (opts) => {
  // console.log(opts.Utype);
  switch (opts.Utype){
    case Utype.GATEWAY : Qkey = RULE.CURVE_RULE.replace("Utype",'ambient-'+opts.beeId);break;
    case Utype.ROOM : Qkey =  RULE.CURVE_RULE.replace("Utype",opts.roomId);break;
    case Utype.TERMINAL : Qkey =  RULE.CURVE_RULE.replace("Utype",opts.deviceId);break;
    case Utype.TriUnit : Qkey =  RULE.TriCurve_RULE.replaceAll("Utype",opts.deviceId).replaceAll("Vtype",opts.Vtype) + ";" +
      RULE.CURVE_RULE.replace("Utype",opts.deviceId);break;
  }
  return Qkey.replace("Vtype",opts.Vtype).replace(".TimeScale",opts.Vtype === Vtype.E?'.'+opts.TimeScale:"").replaceAll("dateRange",opts.DateRange)
}
const forecastAPI = (opts) => {
  return ""
}
const KAPI = (opts) => {
  switch (opts.Utype){
    case Utype.GATEWAY : Qkey = RULE.K_RULE.replace("beeId",opts.beeId);break;
    case Utype.ROOM : Qkey = RULE.K_RULE.replace("ambient-beeId",opts.roomId);break;
    case Utype.TERMINAL : Qkey = RULE.K_RULE.replace("ambient-beeId",opts.deviceId);break;
  }
  return Qkey.replace("TimeScale",opts.TimeScale).replace("Vtype",opts.Vtype).replace("TopX",'#'+opts.TopX)
}
const stateAPI = (opts) => {
  switch (opts.Utype){
    case Utype.GATEWAY : Qkey = RULE.STATE_RULE.replace("Utype",'ambient-'+opts.beeId);break;
    case Utype.TERMINAL : Qkey = RULE.STATE_RULE.replace("Utype",opts.deviceId);break;
    case Utype.ROOM : Qkey = RULE.STATE_RULE.replace("Utype",opts.roomId);break;
    case Utype.TriUnit : Qkey = RULE.TriState_RULE.replaceAll("Utype",opts.deviceId).replaceAll("Vtype",opts.Vtype);break;
    default : Qkey = RULE.STATE_RULE.replace(":Utype","");break;
  }
  return Qkey.replaceAll("Vtype",opts.Vtype);
}
const switchAPI = (opts) => {
  if(opts.deviceId)Qkey = RULE.SWITCH_RULE.replace("Utype",opts.deviceId)
  else Qkey = RULE.SWITCH_RULE.replace(":Utype","")
  return Qkey
}

const friendAPI = (opts) => {
  if(opts.beeId instanceof Array){

  }else{
    Qkey = RULE.FRIEND_RULE.replace("beeId",opts.beeId)
  }
  return Qkey;
}
const logAPI = (opts) => {
  "curve.deviceId.controlled:#recodes"
  "curve.type.executed:#recodes"
  return ""
}

export const UnitType = (deviceId) => {
  if(deviceId.indexOf("Sck") > -1)return Utype.SOCKET
  if(deviceId.indexOf("Trm") > -1)return Utype.AMMETER
  if(deviceId.indexOf("Lk1") > -1)return Utype.LIGHT
  if(deviceId.indexOf("Lk2") > -1)return Utype.DOUBLE_LIGHT
  if(deviceId.indexOf("Lk3") > -1)return Utype.TRIPLE_LIGHT
}
